// extracted by mini-css-extract-plugin
export default {"header":"CopyConfigurationPopupProvider_header__-7yPy","select":"CopyConfigurationPopupProvider_select__OKIcc"};